import { Note } from "./note";

export class BillingNote extends Note {
    systemMessage: string;
}